import { useEffect, useState } from "react";
import { RequestServer } from "../../../../../utils/services";
import { APIRoutes } from "../../../../../constants";
import { ConfiguredAgenda, TAgendaItem } from "./type";
import { AgendaResponse } from "../../../../../pages/expert-project/types";


function generateUniqueId() {
  return Math.random().toString(36).substr(2, 9);
}

function formatAgendaResponsesWithFlags(item: TAgendaItem): AgendaResponse[] {
  const { questions = [], agenda_responses = [] } = item;

  return questions.map((questionText) => {
    const matched = agenda_responses.find(
      (r) => r.question?.trim() === questionText?.trim()
    );

    return matched
      ? { ...matched, inputId: generateUniqueId(), isNewQuestion: false }
      : {
          inputId: generateUniqueId(),
          question: questionText,
          answer: "",
          expert_note: "",
          isNewQuestion: true,
        };
  });
}
// agenda.status = 'New agenda', 'Sent', 'RespondedByAdmin', 'RespondedByExpert', 'Declined'
// New Agenda -> if no pe_agenda exist for this agenda
// Sent -> if pe_agenda exist for this agenda but not responded
// RespondedByAdmin -> if pe_agenda exist for this agenda and responded by admin
// RespondedByExpert -> if pe_agenda exist for this agenda and responded by expert
// Declined -> if pe_agenda exist for this agenda and declined
export function useProjectAgendaItems(fk_project: number, fk_pe: number) {
  const [agendas, setAgendas] = useState<ConfiguredAgenda[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndTransform = async () => {
      setLoading(true);
      try {
        // Call agenda API
        const agendaRes = await RequestServer(
          `${APIRoutes.agenda}?action=GetAgenda&in___state=Added&fk_project=${fk_project}`,
            'get'
        );
        // Call PE Agenda API
        const peAgendaRes = await RequestServer(
          `${APIRoutes.PE_AGENDA}?fk_project=${fk_project}&fk_pe=${fk_pe}&in___status=Sent,RespondedByExpert,RespondedByAdmin,Declined&show_columns=agenda_responses,fk_agenda,id,status,updated_at,agenda_responded_on`,
            'get'
        );

        const agendaData = agendaRes?.data || [];
        const peAgendaData = peAgendaRes?.data || [];
        const peAagendaMap = new Map<number, any>(
          peAgendaData.map((item: any) => [item.fk_agenda, item])
        );

        const merged = agendaData.map((raw: any) => {
          
          
          const matchedPEAgenda = peAagendaMap.get(raw.id);

          const status = matchedPEAgenda
            ? matchedPEAgenda.status
              ? matchedPEAgenda.status
              : "NewAgenda"
            : 'NewAgenda';
          
          const item = {
            id: raw.id,
            status,
            agenda_responses: matchedPEAgenda?.agenda_responses || [],
            title: raw.title || null,
            questions: raw.agenda?.questions || [],
            agenda_updated_at: raw.updated_at || null,
            pe_agenda_updated_at: matchedPEAgenda?.updated_at || null,
            agenda_responded_on: matchedPEAgenda?.agenda_responded_on || null,
          };

          item.agenda_responses = formatAgendaResponsesWithFlags(item);
          return item;
        });

        setAgendas(merged);
      } catch (err: any) {
        console.error("Agenda fetch error:", err);
        setError("Failed to load agenda data");
      } finally {
        setLoading(false);
      }
    };

    if (fk_project && fk_pe) {
      fetchAndTransform();
    }
  }, [fk_project, fk_pe]);

  return { agendas, loading, error };
}
